<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">

  <form class="form-wrapper" [formGroup]="mitarbeiterForm" autocomplete=off>

    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.anrede' | translate }}</mat-label>
      <mat-select formControlName="anrede">
        <mat-option [value]="null">Keine</mat-option>
        <mat-option *ngFor="let anrede of ($anreden | async)" [value]="anrede.key">
          {{anrede.key }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="mitarbeiterForm.controls.anrede.invalid">{{ getErrorMessage('anrede') | translate }}</mat-error>
    </mat-form-field>

      <mat-checkbox
        class="checkboxAbstand"
        formControlName="aktiv"
      >
        {{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.aktiv' | translate }}
      </mat-checkbox>
    </div>
    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.vorname' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.vorname' | translate"
        formControlName="vorname">
      <mat-error *ngIf="mitarbeiterForm.controls.vorname.invalid">{{ getErrorMessage('vorname') | translate }}</mat-error>
    </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.name' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.name' | translate"
          formControlName="name"
        />
        <mat-error *ngIf="mitarbeiterForm.controls.name.invalid">{{ getErrorMessage('name') | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.email' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.email' | translate"
        formControlName="email"
      />
      <mat-error *ngIf="mitarbeiterForm.controls.email.invalid">{{ getErrorMessage('email') | translate }}</mat-error>
    </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.geburtstag' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.geburtstag' | translate"
          [matDatepicker]="picker"
          formControlName="geburtstag"
        />
        <mat-datepicker-toggle  [tabIndex]="-1" matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="mitarbeiterForm.controls.geburtstag.invalid">{{ getErrorMessage('geburtstag') | translate }}</mat-error>
      </mat-form-field></div>
    <div class="eineLinie">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.adr1' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.adr1' | translate"
          formControlName="str1"
        />
        <mat-error *ngIf="mitarbeiterForm.controls.str1.invalid">{{ getErrorMessage('str1') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.adr2' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.adr2' | translate"
          formControlName="str2"
        />
        <mat-error *ngIf="mitarbeiterForm.controls.str2.invalid">{{ getErrorMessage('str2') | translate }}</mat-error>
      </mat-form-field></div>
    <div class="eineLinie">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.plz' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.plz' | translate"
          formControlName="plz"
          [evenNumbersOnlyMax]=9999

          onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off
        />
        <mat-error *ngIf="mitarbeiterForm.controls.plz.invalid">{{ getErrorMessage('plz') | translate }}</mat-error>
      </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.ort' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.ort' | translate"
        formControlName="ort"
      />
      <mat-error *ngIf="mitarbeiterForm.controls.ort.invalid">{{ getErrorMessage('ort') | translate }}</mat-error>
    </mat-form-field>
</div>
    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.mobile' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.mobile' | translate"
        formControlName="mobile"
      />
      <mat-error *ngIf="mitarbeiterForm.controls.mobile.invalid">{{ getErrorMessage('mobile') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.rolle' | translate }}</mat-label>
      <mat-select #mySel formControlName="rolle" multiple>
        <mat-option *ngFor="let rolle of ($rollen | async)" [value]="rolle.id" [disabled]="rolle.disabled==true">
          {{rolle.key}}
        </mat-option>
        <div class="row no-gutters pb-1 buttonPlacement">
          <button
            mat-raised-button
            color="accent"
            (click)="okClicked()"
          >
            {{ data.submitButtonLabel | translate }}
          </button>
        </div>
      </mat-select>
      <mat-error *ngIf="mitarbeiterForm.controls.rolle.invalid">{{ getErrorMessage('rolle') | translate }}</mat-error>
    </mat-form-field>
    </div>
    <!--
    <div class="dreiLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.ferientage' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.ferientage' | translate"
        formControlName="ferientage"
        [decimalNumbersOnlyMax]=100
        [kommaStellen]=1
        onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off
      />
      <mat-error *ngIf="mitarbeiterForm.controls.ferientage.invalid">{{ getErrorMessage('ferientage') | translate }}</mat-error>
    </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.stundenProTag' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.stundenProTag' | translate"
          formControlName="stundenProTag"
          [decimalNumbersOnlyMax]=100
          [kommaStellen]=2
          onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off
        />
      </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.anstellungprozent' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.mitarbeiterDialog.anstellungprozent' | translate"
        formControlName="anstellungprozent"
        [evenNumbersOnlyMax]=100
        onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off
      />
      <mat-error *ngIf="mitarbeiterForm.controls.anstellungprozent.invalid">{{ getErrorMessage('anstellungprozent') | translate }}</mat-error>
    </mat-form-field></div> -->
  </form>
  <div *ngIf="data.id" class="randAbstand">
    <div class="dreiEineLinie">
      <h2 mat-dialog-title>{{ 'pages.mitarbeiterverwaltung.firmaDialog.firmaZeiten' | translate }}</h2>
      <form [formGroup]="yearForm" autocomplete=off>
      <mat-checkbox formControlName="year"
                    class="checkboxAbstand"
                    (change)="filterUserInfo()"
      >
        {{ 'pages.mitarbeiterverwaltung.jahr' | translate }}</mat-checkbox>
      </form>
      <div class="add-button-container">
        <button (click)="addUserinfo()" color="accent" matTooltip="Info Zeiten Hinzufügen" mat-mini-fab class="pluscolor add-button-container">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <app-saldo-table [saldo]="$userInfos | async"></app-saldo-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">


<mat-dialog-actions align="end">
  <button
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
    [tabIndex]="-1"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="mitarbeiterForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>

</mat-dialog-actions>
